import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompletedFormsService {

  private dataSource = new BehaviorSubject(null);
  
  constructor(
    private _http: HttpClient
  ) { }

  refreshCount(data: any[]) {
    this.dataSource.next(data);
  }
  
  getCompletedForms(organizationId, isHelpAdmin?) {
    let endPoint = ""
    if(isHelpAdmin) {
      endPoint = `${environment.url}/completedForms/${organizationId}?isHelpAdmin=${isHelpAdmin}`
    } else {
      endPoint = `${environment.url}/completedForms/${organizationId}`
    }
    return this._http.get(endPoint);
  }

  restoreArchivedForms(requestData) {
    return this._http.put(environment.url + "/forms/archived/restore", requestData, { headers: { "hideLoader": "true" }});
  }
}
